import {Component, HostBinding, Input} from '@angular/core';
import {finalize} from "rxjs/operators";
import {Proverb} from "../../models/proverb.model";
import {ProverbBookmarkService} from "../../services/proverb/proverb-bookmark.service";
import {GlobalEventService} from "../../services/global-event/global-event.service";

@Component({
  selector: 'app-word-detail-proverb',
  template: `
    <ng-container *ngIf="proverb">

      <div class="proverb-head-box">
        <div class="proverb-subject-box">
          <div class="subject-txt-box">{{ proverb.proverb2 }}</div>

        </div>
        <div class="proverb-bookmark-box">

          <article class="bookmark-btn-box">
            <button type="button"
                    class="bookmark-btn {{ getBmCss(proverb) }}"
                    (click)="ToggleBookmark($event)"></button>
          </article>


        </div>


      </div>
      <div class="proverb-body-box">

        <div class="proverb-txt-box"
             [innerHTML]="proverb.meaning2 | resize"></div>

      </div>

    </ng-container>
  `,
})
export class WordDetailProverbComponent {
  @HostBinding('class') class = 'proverb-item-box';
  @Input() proverb?: Proverb;

  private sendingBookmark = false;

  constructor(
    protected bmSvc: ProverbBookmarkService,
    private globalEventSvc: GlobalEventService,
  ) {
  }

  protected ToggleBookmark(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.globalEventSvc.Click(event, true);

    const proverb = this.proverb;
    if (!proverb) {
      throw new Error('WordDetailProverbComponent::ToggleBookmark() proverb is null or undefined');
    }
    if (this.sendingBookmark) {
      return; // 이미 보내고 있다.
    }
    this.sendingBookmark = true;
    proverb.bookmark = !proverb.bookmark;
    this.bmSvc.sendBookmark(proverb.id, proverb.bookmark).pipe(
      finalize(() => this.sendingBookmark = false)
    ).subscribe({
      next: data => console.log(data),
      error: err => {
        console.error('WordDetailProverbComponent::ToggleBookmark() failed', proverb.id, err);
        proverb.bookmark = !proverb.bookmark;
      },
    });
  }

  protected getBmCss(dialect: Proverb): string {
    if (this.sendingBookmark) {
      return 'ing';
    }
    return dialect.bookmark ? 'on' : '';
  }
}
